import cloneDeep from "clone-deep";
import { getDefaultOption } from "../../../../../../helpers/forms/select.js";
export const getDefaultSelectedOption = (person)=>person?.options.find((option)=>option.selected) ?? person.options[0];
export const generateDefaultRoom = (people)=>{
    const room = {
        people: []
    };
    for (const eachPeople of people){
        const person = {
            value: eachPeople.value
        };
        if (eachPeople.options?.length) {
            const selectedOption = getDefaultOption(eachPeople.options);
            if (!selectedOption) continue;
            person.selectedOptions = new Array(eachPeople.value).fill(selectedOption.value);
        }
        room.people.push(person);
    }
    return room;
};
export const generateDefaultValue = (people)=>{
    const room = generateDefaultRoom(people);
    return [
        room
    ];
};
export const checkSelectedOptions = (people, roomPerson)=>{
    const newRoomPerson = cloneDeep(roomPerson);
    if (!newRoomPerson.selectedOptions) newRoomPerson.selectedOptions = [];
    const selectedOption = getDefaultOption(people.options);
    if (!selectedOption) return newRoomPerson.selectedOptions;
    for(let i = newRoomPerson.selectedOptions.length, length = newRoomPerson.value; i < length; i++){
        newRoomPerson.selectedOptions.push(selectedOption.value);
    }
    if (newRoomPerson.selectedOptions.length > newRoomPerson.value) {
        newRoomPerson.selectedOptions = newRoomPerson.selectedOptions.slice(0, newRoomPerson.value);
    }
    return newRoomPerson.selectedOptions;
};
export const transformInitialRooms = (rooms, people)=>{
    rooms.forEach((room)=>{
        room.people.forEach((person, personIndex)=>{
            if (people[personIndex].options?.length) {
                if (!person.selectedOptions) person.selectedOptions = [];
                person.selectedOptions = checkSelectedOptions(people[personIndex], person);
            }
        });
    });
    return rooms;
};

//# sourceMappingURL=utils.js.map